import {Component} from '@angular/core';
import {SvgIconComponent} from "../../common-components/svg-icon/svg-icon.component";
import {NavigationBoxComponent} from "../../common-components/navigation-box/navigation-box.component";
import {InputTextComponent} from "../../common-components/input-text/input-text.component";
import {InputPasswordComponent} from "../../common-components/input-password/input-password.component";
import {FormControl, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    SvgIconComponent,
    NavigationBoxComponent,
    InputTextComponent,
    InputPasswordComponent,
    TranslocoDirective
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent {
  protected userName: FormControl<string> = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required]
  });
  protected password: FormControl<string> = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required]
  });

  constructor(private router: Router) {
  }

  protected isActive(): boolean {
    return this.password.valid && this.userName.valid;
  }

  protected login() {
    if (!this.isActive()){
      this.userName.markAsTouched();
      this.password.markAsTouched();
      return;
    }
    this.navigate('');
  }

  private navigate(route: string): void {
    this.router.navigate([route]).then();
  }
}
